import React from 'react';
import { Check, Shield, Download, Smartphone } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalOffer() {
  return <section className="py-16 px-4 bg-white border-t-8 border-brand-red" data-id="element-48">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49">
        <div className="inline-block bg-red-100 text-brand-red font-bold px-6 py-2 rounded-full mb-8 animate-pulse" data-id="element-50">
          ⚠️ URGENCIA FINAL
        </div>

        <h2 className="text-4xl md:text-5xl font-heading font-black text-black mb-6 uppercase" data-id="element-51">
          ⚠️ ESTA OFERTA ES POR TIEMPO LIMITADO
        </h2>

        <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-2xl p-8 mb-10 text-left max-w-xl mx-auto" data-id="element-52">
          <p className="text-2xl font-bold text-center mb-6" data-id="element-53">
            Hoy podés llevarte:
          </p>
          <ul className="space-y-4" data-id="element-54">
            {['Más de 300 remedios naturales', 'La guía completa paso a paso', 'Los 10 libros digitales de regalo', 'Acceso inmediato', 'Actualizaciones futuras'].map((item, idx) => <li key={idx} className="flex items-center gap-3" data-id="element-55">
                <Check className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-56" />
                <span className="text-xl font-medium text-gray-800" data-id="element-57">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="mb-10" data-id="element-58">
          <p className="text-xl font-bold text-gray-500 uppercase tracking-widest mb-2" data-id="element-59">
            💰 OFERTA FINAL
          </p>
          <p className="text-2xl font-bold text-gray-800 mb-2" data-id="element-60">
            TODO ESTO HOY POR SOLO:
          </p>
          <p className="text-3xl text-gray-400 line-through font-bold mb-2" data-id="element-61">
            $49.990
          </p>
          <p className="text-6xl md:text-7xl font-black text-brand-red" data-id="element-62">
            👉 $16.990 ARS
          </p>
        </div>

        <CTAButton text="🌿 QUIERO MI GUÍA COMPLETA AHORA" className="mb-8" data-id="element-63" />

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-sm font-bold text-gray-600 bg-gray-100 py-4 px-6 rounded-xl inline-flex flex-wrap" data-id="element-64">
          <div className="flex items-center gap-2" data-id="element-65">
            <Shield className="w-5 h-5 text-brand-green" data-id="element-66" />
            <span data-id="element-67">Pago seguro</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-68">
            <Download className="w-5 h-5 text-brand-green" data-id="element-69" />
            <span data-id="element-70">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-71">
            <Smartphone className="w-5 h-5 text-brand-green" data-id="element-72" />
            <span data-id="element-73">Disponible para celular y computadora</span>
          </div>
        </div>
      </div>
    </section>;
}